import { environmentConfig } from './config.environment';
import { staticConfig } from './config.static';

const config = Object.assign(staticConfig, environmentConfig);

export default config;
